import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { Message } from 'primeng/api';
import { AppSettings } from '../../../shared/app.settings';
import { StorageService } from './../../services/storage.service';
import { UiService } from './../../services/ui.service';
import { UserCommonService } from './../../services/user-common.service';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html'
})

export class EditProfileComponent implements OnInit {
  @Input() editProfilePopup: boolean;
  @Output() showProfilePopup: EventEmitter<any> = new EventEmitter();
  editProfileForm = new FormGroup({
    firstName: new FormControl(),
    lastName: new FormControl(),
    email: new FormControl(),
    username: new FormControl(),
    phone: new FormControl(),
    phoneCode: new FormControl()
  });
  countryCodeList = AppSettings.COUNTRY_CODE;
  message: Message[] = [];
  profileUrl = AppSettings.DEFAULT_PROFILE_IMAGE_URL;
  fileUploadUrl: string = AppSettings.UPLOAD_FILE_URL;
  uploadedImgId = '';
  chooseLabel;
  first_name;
  last_name;
  email_id;
  phone_no;
  edit_profile;
  countryCodeDefault;
  userInfo: any;
  isStaffUser = false;
  isPhoneNumberValid = true;

  constructor(
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private commonServices: UserCommonService,
    private uiSerice: UiService,
    private commonBindingDataService: CommonBindingDataService,
  ) { }

  ngOnInit() {
    this.userInfo = this.storageService.getItem(AppSettings.USER_DETAILS);
    if (this.userInfo.roles[0].id === '2' || this.userInfo.roles[0].id === '9') {
      this.isStaffUser = true;
    }
    this.chooseLabel = this.commonBindingDataService.getLabel('label_upload');
    this.countryCodeDefault = '+1';
    this.editProfileForm = this.formBuilder.group({
      firstName: ['', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(50),
        Validators.pattern(AppSettings.NAME_PATTERN)
      ]],
      lastName: ['', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(50),
        Validators.pattern(AppSettings.NAME_PATTERN)
      ]],
      email: ['', [
        Validators.required,
        Validators.pattern(AppSettings.EMAIL_PATTERN)
      ]],
      phone: ['', [
        // Validators.required,
        // Validators.minLength(12),
        Validators.maxLength(12),
        Validators.pattern(AppSettings.NUMBER_PATTERN)
      ]],
      phoneCode: ['', [Validators.required]]
    });

    this.edit_profile = this.commonBindingDataService.getLabel('label_edit_profile');
    this.first_name = this.commonBindingDataService.getLabel('label_first_name');
    this.last_name = this.commonBindingDataService.getLabel('label_last_name');
    this.email_id = this.commonBindingDataService.getLabel('label_email_imp');
    this.phone_no = this.commonBindingDataService.getLabel('label_phone_number');
    if (this.isStaffUser) {
      this.phone_no = this.commonBindingDataService.getLabel('label_phone_number');
      this.editProfileForm.controls.phoneCode.setValidators(null);
      this.editProfileForm.controls.phone.setValidators([
        // Validators.required,
        // Validators.minLength(12),
        Validators.maxLength(12),
        Validators.pattern(AppSettings.NUMBER_PATTERN)
      ]);
      this.editProfileForm.controls.phoneCode.updateValueAndValidity();
      this.editProfileForm.controls.phone.updateValueAndValidity();
    }
  }

  setData() {
    this.countryCodeList = AppSettings.COUNTRY_CODE;
    const userObj: any = this.storageService.getItem(AppSettings.USER_DETAILS);
    if (userObj !== undefined && userObj !== null) {
      this.editProfileForm.controls.firstName.setValue(userObj.firstName);
      this.editProfileForm.controls.lastName.setValue(userObj.lastName);
      this.editProfileForm.controls.email.setValue(userObj.email);
      this.editProfileForm.controls.phone.setValue(userObj.phoneNum);
      this.editProfileForm.controls.phoneCode.setValue(this.countryCodeDefault);

      if (userObj.userDetails !== undefined && userObj.userDetails !== null && userObj.userDetails.profileImage !== null) {
        this.profileUrl = AppSettings.GET_FILE_THUMB_URL + userObj.userDetails.profileImage;
      }
    }
  }

  closeEditProfile(event: any) {
    this.showProfilePopup.emit(false);
  }

  onUploadProfileImage(response) {
    this.profileUrl = AppSettings.GET_FILE_THUMB_URL + response.fileId;
    this.uploadedImgId = response.fileId;
  }

  phoneNumberFormat(data) {
    if (data) {
      return data.split('-').join('');
    }
  }

  updateProfile(event: any) {
    const editProfileData = {
      firstName: this.editProfileForm.controls.firstName.value,
      lastName: this.editProfileForm.controls.lastName.value,
      email: this.editProfileForm.controls.email.value,
      phoneNum: this.phoneNumberFormat(this.editProfileForm.controls.phone.value),
      profileImage: this.uploadedImgId,
      numCountryCode: this.editProfileForm.controls.phoneCode.value,
    };

    this.commonServices.updateUserProfile(editProfileData).subscribe(results => {
      if (results.user !== null && results.user !== undefined) {
        this.storageService.setItem(AppSettings.USER_DETAILS, results.user);
        this.uiSerice.showMessage(this.commonBindingDataService.getLabel('label_profile_updated_successfully'),
          AppSettings.MESSAGE_TYPES.SUCCESS);
        setTimeout(() => {
          this.showProfilePopup.emit(false);
          this.uiSerice.profileUpdated();
        }, 1000);
      }
    }, (error) => {
      this.uiSerice.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  mobileValidation(event) {
       const formControl = this.editProfileForm.controls;
       let newValue = this.phoneNumberFormat(formControl.phone.value);
       if (event.code === 'Backspace' && newValue.length <= 1) {
         newValue = '';
       }

       const newVal = newValue.replace(/\D/g, '');
       formControl.phone.setValue(newVal);

       if (formControl.phone.value.length >= 1 && formControl.phone.value.length < 10) {
         this.isPhoneNumberValid = false;
       } else {
         this.isPhoneNumberValid = true;
       }
     }

}
